<div class="diagram-navigation">
    <button class="eon-icon-button small turquoise"
            [disabled]="interactionDisabled"
            (click)="positionBack()">
        <i class="chevron-left-s white"></i>
    </button>
    <div class="current-timeframe">{{currentDataDate}}</div>
    <button class="eon-icon-button small turquoise"
            [disabled]="interactionDisabled || timeframeOffset === 0"
            (click)="positionForward()">
        <i class="chevron-right-s white"></i>
    </button>
</div>

<ng-container *ngIf="appliancesDetailData$ | async as detailData">
    <ng-container [ngSwitch]="detailData.viewState">

        <ng-container *ngSwitchCase="ViewState.INITIAL">
            <div class="inflate center-contents">
                {{TEXTS.loading}}
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="ViewState.ERROR">
            <div class="inflate center-contents">
                {{TEXTS.error}}
            </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <div class="appliances-details-diagram-container">
                <div class="appliance-diagram-new" *ngIf="isDataAvailable; else emptyState">
                    <app-appliance-chart
                        [isDetail]="true"
                        [series]="detailData.series"
                        [viewState]="detailData.viewState">
                    </app-appliance-chart>
                </div>
                <ng-template #emptyState>
                    <div class="animation-wrapper">
                        <div class="animation-container"
                             lottie [options]="lottieConfig">
                        </div>
                    </div>
                </ng-template>
            </div>

            <ul class="appliances-list">
                <li *ngFor="let category of detailData.categories"
                    (click)="toggleAccordion(category)">
                    <div class="li-content-wrapper">
                        <div class="list-icon-wrapper">
                            <div class="list-icon"
                                 [ngStyle]="{
                                         'mask-image': 'url(/assets/img/graphics/appliances/'+ category.name.toLowerCase() + '.svg)',
                                        '-webkit-mask-image': 'url(/assets/img/graphics/appliances/'+ category.name.toLowerCase() + '.svg)',
                                        'background-color': category.color
                                     }">
                            </div>
                            <div *ngIf="category.categoryProfileIncompleteOrRetraining"
                                 class="attention-indicator">
                            </div>
                        </div>
                        <div class="grow-space"
                             [style.color]="category.color">
                            {{ translateAppliance(category.name) }}
                        </div>
                        <div>{{ category.kwh }} kWh</div>
                        <div class="cost">{{ category.cost }}</div>
                        <div class="accordion-indicator">
                            <i [ngClass]="{rotated: category.accordionOpen}"></i>
                        </div>
                    </div>
                    <div class="accordion" [hidden]="!category.accordionOpen">
                        <div class="category-list">
                            <div *ngFor="let item of category.appliances">
                                <div class="sub-icon"
                                     [style.mask-image]="determineApplianceCategoryItemPath(item.icon)"
                                     [style.-webkit-mask-image]="determineApplianceCategoryItemPath(item.icon)">
                                </div>
                                <div class="sub-name">{{translateAppliance(item.appliance_instance_id)}}</div>
                                <div class="sub-value"><span>kWh</span> <br> {{item.energy_ws}} </div>
                                <div class="sub-value"><span>€</span> <br> {{item.cost}} </div>
                                <div class="spacer"></div>
                            </div>
                        </div>
                        <p>
                            {{category.description}}
                        </p>
                    </div>
                </li>
            </ul>
        </ng-container>

    </ng-container>
</ng-container>

<ng-container *ngIf="currentNilmPhaseAllowsRetraining$ | async as retrainingAllowed">
    <ng-container *ngIf="retrainingAllowed">
        <div class="center-contents m-t-l">
            <button class="eon-button-new"
                    (click)="enterRetraining$.next(true)"
            >{{LABELS.btnRetraining}}</button>
        </div>
    </ng-container>
</ng-container>
